import { ApiService } from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import UnitHtml  from './unit.html';
import UnitsHtml from './units.html';

export function UnitsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'UnitsCtrl',
    name       : 'app.units',
    templateUrl: UnitsHtml,
    url        : '/units',
    resolve    : {
      bodyTypes        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_body_types/', null, 'bodyTypes'),
      franchises       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_group_or_franchise_types'),
      transmissionTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/transmission_types/', null, 'transmissionTypes'),
      units            : ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('units');

        return workshopAPI.post('/vehicles/for_sale_index', {
          body_type         : cache.filtering.bodyType   ? cache.filtering.bodyType  : '',
          group_or_franchise: cache.filtering.franchise  ? cache.filtering.franchise : '',
          make              : cache.filtering.make       ? cache.filtering.make      : '',
          max_mileage       : cache.filtering.maxMileage ? cache.filtering.maxMileage: '',
          model             : cache.filtering.model      ? cache.filtering.model     : '',
          newest_year       : cache.filtering.newestYear ? cache.filtering.newestYear: '',
          offset            : 0,
          oldest_year       : cache.filtering.oldestYear ? cache.filtering.oldestYear: '',
          order_by          : cache.filtering.order      ? cache.filtering.order     : '',
          page_size         : cache.paging.pageSize || 10,
          price_max         : cache.filtering.maxPrice         ? cache.filtering.maxPrice        : '',
          price_min         : cache.filtering.minPrice         ? cache.filtering.minPrice        : '',
          sale_status       : cache.filtering.sale_status      ? cache.filtering.sale_status     : 'for_sale',
          stock_number      : cache.filtering.stock_number     ? cache.filtering.stock_number    : '',
          transmission      : cache.filtering.transmissionType ? cache.filtering.transmissionType: '',
          used_or_new       : cache.filtering.condition        ? cache.filtering.condition       : ''
        });
      }
    }
  })
  .state({
    controller: 'UnitCtrl',
    name      : 'app.unit',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: UnitHtml,
    url        : '/unit/:id',
    resolve    : {
      advertisingSettings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dealership_advertising_setting'),
      attachments        : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_attachments/for_vehicle', $stateParams.id),
      bodyTypes          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_body_types/', null, 'bodyTypes'),
      company            : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      driveTypes         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/drive_types/', null, 'driveTypes'),
      franchises         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_group_or_franchise_types'),
      fuelTypes          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/fuel_types/', null, 'fuelTypes'),
      hullMaterialTypes  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_hull_materials/', null, 'hullMaterialTypes'),
      hullTypes          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_hull_types/', null, 'hullMaterials'),
      salesStatusTypes   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_sale_status_types'),
      states             : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/state_types'),
      transmissionTypes  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/transmission_types/', null, 'transmissionTypes'),
      vehicleGroups      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_groups_selected', null, 'vehicleBodyTypes'),
      advertising        : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/dealership_advertising_vehicles/for_vehicle', $stateParams.id)
          : [],
      unit: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/vehicle', $stateParams.id)
          : ''
    }
  });
}